import { useSelector } from '@ecommerce/nest-ssr/common';
import { MetaTagsInterface } from 'interfaces/meta-tags.interface';

export const useMetaTags = (): MetaTagsInterface => useSelector((state: { metaTags: MetaTagsInterface; }) => state.metaTags || {});
